<template>
  <section class="text-center mt-10 p-2">
    <div class="max-w-7xl mx-auto">
      <h2 class="text-xl md:text-3xl font-bold">
        <span class="text-orange-500">Ne</span> Vadediyoruz?
      </h2>

      <div class="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4">
        <PromiseCard
          title="Gerçek Kullanıcı Etkileşimi"
          content="Bot veya sahte hesaplar yerine, aktif kullanıcılar tarafından gerçekleştirilen etkileşimler."
          icon="fluent:star-emphasis-20-filled"
        />
        <PromiseCard
          title="Algoritmaya Uygun İşleyiş"
          content="Paylaşımlarınızın platformlar tarafından öne çıkarılmasını sağlayan stratejik etkileşimler."
          icon="carbon:ibm-cloud-backup-and-recovery"
        />
        <PromiseCard
          title="Esnek Kullanım Seçenekleri"
          content="Anlık veya uzun vadeli etkileşim planları ile ihtiyaca uygun çözümler."
          icon="streamline:cursor-click-solid"
        />
        <PromiseCard
          title="Organik Keşfedilirlik"
          content="İçeriklerinizin daha fazla kişiye ulaşmasını sağlayarak organik büyümeyi destekler."
          icon="icon-park-outline:ranking"
        />
      </div>

      <div
        class="landing-orange-container w-full bg-orange-500 text-center rounded-md flex flex-col items-center justify-center mt-8"
      >
        <h3 class="text-2xl font-light text-white p-4">
          Gerçek etkileşimlerle algoritmayı lehinize çevirin, <br />
         <span class=" font-extrabold">sosyal medyada kalıcı bir yer edinin!</span>
        </h3>
        <div class="flex flex-row items-center gap-8 mb-4">
          <span class="text-xs text-white"> Ücretsiz Denemek için </span>
          <NuxtLink
            to="/register"
            class="bg-white text-xs text-orange-500 rounded py-3 px-5"
          >
            Hemen Kaydol
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import PromiseCard from './PromiseCard.vue'
</script>

<style scoped>
.landing-orange-container {
  background-image: url('/img/landing/landing-orange-container.png');
  height: 196px;
}
</style>
